<script lang="ts">
  import { geheZu } from '../router.svelte.ts';

  function zurFernwartung(ereignis: MouseEvent): void {
    ereignis.preventDefault();
    geheZu('/fernwartung');
  }
</script>

<section id="leistungen" class="abschnitt">
  <div class="breite">
    <div class="mitte">
      <h2>Dein persönlicher Technik-Support</h2>
      <p class="vorspann">
        Der Drucker streikt, das WLAN spinnt, das neue Handy will eingerichtet werden. Die üblichen
        Anlaufstellen sind unpersönliche Hotlines mit Fachchinesisch — oder teure IT-Firmen, die sich
        nicht für Privatkunden interessieren. Wir schon.
      </p>
    </div>

    <div class="karten-grid">
      <div class="karte">
        <div class="symbol">📞</div>
        <h3>Telefon</h3>
        <p class="leise">
          Die telefonische Erstberatung ist immer kostenlos. Wir besprechen dein Problem und sagen
          dir ehrlich, wie wir helfen können.
        </p>
      </div>
      <div class="karte">
        <div class="symbol">💻</div>
        <h3>Fernwartung</h3>
        <p class="leise">
          Viele Probleme lösen wir direkt per Bildschirmfreigabe — effizient, verständlich, ohne dass
          du etwas installieren musst, das du nicht verstehst.
        </p>
        <p><a class="pfeil" href="/fernwartung" onclick={zurFernwartung}>Fernwartung starten →</a></p>
      </div>
      <div class="karte">
        <div class="symbol">🏠</div>
        <h3>Vor-Ort</h3>
        <p class="leise">
          Manches lässt sich nicht aus der Ferne lösen. Dann kommen wir zu dir — transparent, planbar,
          im Servicegebiet.
        </p>
      </div>
    </div>

    <div class="zwei-spalten erklaerung">
      <div>
        <h3>Technik verstehen statt nur reparieren</h3>
        <p class="leise">
          Nicht nur reparieren, sondern verständlich erklären — ohne Fachchinesisch. Wir nehmen uns
          Zeit, so lange, bis du es wirklich verstehst: wie Fotos gesichert werden, wie E-Mail
          funktioniert, wie du Ordnung auf deinem Handy hältst.
        </p>
        <p class="leise">
          Du musst kein Technik-Experte sein — dafür gibt es <span class="tb-wordmark">IT-Service Karsten Fischer</span>
        </p>
      </div>
      <div class="karte">
        <h3>Wobei wir dir helfen</h3>
        <ul class="checkliste">
          <li>Drucker- und WLAN-Probleme</li>
          <li>Neues Handy oder neuen Laptop einrichten</li>
          <li>Fotos und WhatsApp sichern</li>
          <li>E-Mail, Apps, Datensicherung</li>
          <li>Allgemeine Technik-Grundlagen</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<style>
  .erklaerung {
    margin-top: 3.5rem;
  }

  .pfeil {
    font-weight: 700;
    color: var(--tb-navy-700);
    text-decoration: none;
  }

  .pfeil:hover {
    text-decoration: underline;
  }
</style>
